<template>
  <b-col md="12" sm="12">
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
        <b-form v-on:submit.prevent="onSubmit">
          <h1 v-if="!editar && !visualizar"><strong>Novo Link</strong></h1>
          <h1 v-if="editar"><strong>Editar Link</strong></h1>
          <h1 v-if="visualizar"><strong>Visualizar Link</strong></h1> <b-row>
            <b-col sm="12" md="6">
              <b-form-group label="Título: *">
                <b-input-group class="mb-3">
                  <b-form-input type="text" class="form-control" placeholder="Título" autocomplete="titulo"
                    v-model.trim="$v.form.titulo.$model" :disabled="disable_buttons || visualizar" maxlength="100"
                    :state="chkState('titulo')"/>
                  <b-form-invalid-feedback id="input1LiveFeedback1">Título é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
              <b-form-group label="Cor do bloco de apresentação: *">
                <input type="color" :disabled="disable_buttons || visualizar" v-model.trim="$v.form.cor_bloco.$model" :state="chkState('cor_bloco')">
                <b-form-invalid-feedback :state="chkState('cor_bloco')" id="input1LiveFeedback1">Cor do bloco é obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group label="Url: *">
                <b-form-input type="text" class="form-control" placeholder="Url" autocomplete="url"
                  v-model.trim="$v.form.url.$model"  :state="chkState('url')" :disabled="disable_buttons || visualizar"/>
                <b-form-invalid-feedback id="input1LiveFeedback9">Url é obrigatória.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
                <b-form-group label="Status: *">
                  <b-form-radio-group v-model="form.ativo" :disabled="disable_buttons || visualizar" :options="status"
                    required />
                </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col v-if="!loading && !visualizar" md="3">
            <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
              <i class="fa fa-plus"></i>&nbsp;
              <span>Salvar</span>
            </b-button>
          </b-col>
          <b-col v-if="loading && !visualizar" md="3">
            <b-button block variant="primary" :disabled="false" v-on:click="onSubmit">
              <b-spinner small type="grow"></b-spinner>Enviando...
            </b-button>
          </b-col>
          <b-col md="3">
            <b-button block variant="secondary" :disabled="disable_buttons" @click="voltar()">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-col>
</template>

<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

const regexUrl = new RegExp(/[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i);

export default {
  name: 'Cadastro',
  components: {
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      titulo: {
        required
      },
      cor_bloco: {
        required
      },
      ativo: {
        required
      },
      url: {
        required
      }
    }
  },
  created() {
    if (this.$route.params.id) {
      this.load(this.$route.params.id)


      let path = this.$route.path
      path = path.split('/')

      if (path[3] === 'editar') {
        this.editar = true
      }

      if (path[3] === 'visualizar') {
        this.visualizar = true
      }
    }
  },
  data() {
    return {
      loading: false,
      form: {
        id: null,
        titulo: '',
        cor_bloco: '#B0B0B0',
        ativo: true,
        url: ''
      },
      disable_buttons: false,
      visualizar: false,
      editar: false,
      salvarForm: false,
      status: [
        { value: true, text: 'Ativo' },
        { value: false, text: 'Inativo' }
      ],
    }
  },
  computed: {
    isValid() {
      return !this.$v.form.$anyError
    },
    isValidSelection() {
      return this.selected !== '' && this.selected !== 'forbidden value'
    },
  },
  mounted() {
    // 
  },
  watch: {
    //
  },
  methods: {
    load(id) {
      Vue.http.get('api/link/' + id).then(response => {
        let data = response.body.data[0]

        this.form.id = data.id
        this.form.titulo = data.titulo
        this.form.ativo = data.ativo
        this.form.cor_bloco = data.cor_bloco

        if (data.url !== null) {
          this.mostra_url = true
        }
        this.form.url = data.url
      })
    },
    cadastrar() {
      let data = {
        titulo: this.form.titulo,
        cor_bloco: this.form.cor_bloco,
        ativo: this.form.ativo,
        url: this.form.url
      }

      this.loading = true
      this.disable_buttons = true
      Vue.http.post('api/link', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push({ path: '/links' })
        } else {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.disable_buttons = false
        this.loading = false
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    alterar() {
      let data = {
        titulo: this.form.titulo,
        cor_bloco: this.form.cor_bloco,
        ativo: this.form.ativo,
        url: this.form.url
      }

      this.loading = true
      this.disable_buttons = true

      Vue.http.put('api/link/' + this.form.id, data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push({ path: '/links' })
        } else {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }

        this.disable_buttons = false
        this.loading = false
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    confirmar() {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          if (this.form.id) {
            this.alterar()
          } else {
            this.cadastrar()
          }
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit() {
      if (this.form.url !== '') {
        if (!regexUrl.test(this.form.url)) {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error('Url Inválida!', 'Alerta', 5000)
          return false
        }
      }

      this.salvarForm = true
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState(val) {
      const field = this.$v.form[val]
      if (!field && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate(route) {
      this.$router.push(route)
    },
    voltar() {
      window.history.go(-1)
    },
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/links/LinkForm.vue